<script setup lang="ts">
import UiMessage from "./ui/UiMessage.vue";
import { useStore } from "vuex";
import { themeColorStore } from "@/store/themeColor";
import { useStopZoom } from "@/package/global-use-case/useStopZoom";
import { useSavePwa } from "@/package/global-use-case/useSavePwa";
import { usePullToRefresh } from "./package/global-use-case/usePullToRefresh";
import { onBeforeMount, onMounted } from "vue";

defineOptions({ name: "App" });

const { isAppInstalled, showInstallPrompt } = useSavePwa();
const vuexStore = useStore();
const colorStore = themeColorStore();

const checkedPwaSave = () => {
  !isAppInstalled.value && showInstallPrompt();
};

const updateSystemCountry = (countryCode: "ru" | "kz" | "md") => {
  localStorage.setItem("country", countryCode);
  vuexStore.commit("system/SET_SYSTEM_COUNTRY", countryCode);
};

onBeforeMount(async () => {
  colorStore.SET_THEME_COLOR_FROM_LOCAL_STORAGE();
  await vuexStore.dispatch("system/getSystemCountries");
});

onMounted(() => {
  usePullToRefresh();
  checkedPwaSave();
  useStopZoom();

  if (window.location.host.includes("localhost")) {
    return;
  }

  const isKzHost = window.location.host.includes("kz");
  const currentCountry = localStorage.getItem("country");
  const newCountry = isKzHost ? "kz" : "ru";

  if (currentCountry !== newCountry) {
    updateSystemCountry(newCountry);
  }
});
</script>

<template>
  <RouterView />

  <UiMessage />
</template>

<style lang="scss">
input {
  outline: none;
  color-scheme: dark;
}

input[data-autocompleted] {
  background-color: transparent !important;
}
</style>
